import React from 'react';
import Grid2 from '@mui/material/Grid2';
import WatchlistTable from '../../watchlist_table/WatchlistTable';
import { WatchlistApplyFactorSourceProvider } from '../../../context/WatchlistApplyFactorSourceContext';
import { workspaceSectionSx } from '../../../styles/workspaceChromeStyles';

export default function DashboardWatchlistSection({
    active = true,
    user,
    industries,
    portfolioEditor,
    portfolioDialogOpen = false,
    onClosePortfolioDialog,
    watchlistAttributeSnapshot = null,
    industriesLoading,
    coreLoadVisualLoading = false,
    watchlistUploadBusy = false,
    watchlistPublicationRefreshBusy = false,
    watchlistPublicationNeedsAttention = false,
    liveQuotesByCogniveId,
    liveQuotesLastUpdatedAt,
    imputedWatchlistCogniveIds,
    ignoredWatchlistCogniveIds,
    selectedFactorModel,
    selectedBetaSource,
    factorContextUnavailable = false,
    factorMatricesUnavailable = false,
    watchlistUploadControl,
    watchlistM365SyncControl,
    watchlistReviewHandoff = null,
    onWatchlistReviewHandoff = null,
    watchlistContextSync = null,
    showWatchlistUploadGuide,
    onDismissWatchlistGuide,
    newsByIdentity,
    newsMoverThresholdPct,
    newsLastUpdatedAt,
    newsRecencyWindowHours,
    newsReadArticleIds,
    onNewsArticleRead,
    deepDiveFocusAreas,
    onLoadNewsDetails,
    newsArticlesByIdentity,
    newsArticlesLoadingByIdentity,
    newsArticlesErrorByIdentity,
    securityOperationStatus = null,
}) {
    // The review dialog inside the prebuilt upload control reads Apply's
    // factor-data readiness from the polled context status.
    return (
        <WatchlistApplyFactorSourceProvider
            value={watchlistContextSync?.status?.apply_factor_source_ready}
        >
            <Grid2 container sx={workspaceSectionSx} spacing={2}>
                <WatchlistTable
                    active={active}
                    user={user}
                    rows={industries}
                    portfolioEditor={portfolioEditor}
                    portfolioDialogOpen={portfolioDialogOpen}
                    onClosePortfolioDialog={onClosePortfolioDialog}
                    watchlistAttributeSnapshot={watchlistAttributeSnapshot}
                    // Row requests can finish before the core transaction
                    // publishes the complete Watchlist snapshot.
                    loading={industriesLoading || coreLoadVisualLoading || watchlistUploadBusy}
                    replacingWatchlist={watchlistUploadBusy}
                    liveQuotesByCogniveId={liveQuotesByCogniveId}
                    liveQuotesLastUpdatedAt={liveQuotesLastUpdatedAt}
                    imputedCogniveIds={imputedWatchlistCogniveIds}
                    ignoredCogniveIds={ignoredWatchlistCogniveIds}
                    factorModelLabel={selectedFactorModel}
                    betaSource={selectedBetaSource}
                    factorContextUnavailable={factorContextUnavailable}
                    factorMatricesUnavailable={factorMatricesUnavailable}
                    uploadControl={watchlistUploadControl}
                    m365SyncControl={watchlistM365SyncControl}
                    reviewHandoff={watchlistReviewHandoff}
                    onReviewHandoff={onWatchlistReviewHandoff}
                    watchlistContextSync={watchlistContextSync}
                    showUploadGuide={showWatchlistUploadGuide}
                    onDismissGuide={onDismissWatchlistGuide}
                    newsByIdentity={newsByIdentity}
                    newsMoverThresholdPct={newsMoverThresholdPct}
                    newsLastUpdatedAt={newsLastUpdatedAt}
                    newsRecencyWindowHours={newsRecencyWindowHours}
                    newsReadArticleIds={newsReadArticleIds}
                    onNewsArticleRead={onNewsArticleRead}
                    deepDiveFocusAreas={deepDiveFocusAreas}
                    onLoadNewsDetails={onLoadNewsDetails}
                    newsArticlesByIdentity={newsArticlesByIdentity}
                    newsArticlesLoadingByIdentity={newsArticlesLoadingByIdentity}
                    newsArticlesErrorByIdentity={newsArticlesErrorByIdentity}
                    securityOperationStatus={securityOperationStatus}
                    publicationRefreshBusy={watchlistPublicationRefreshBusy}
                    publicationNeedsAttention={watchlistPublicationNeedsAttention}
                />
            </Grid2>
        </WatchlistApplyFactorSourceProvider>
    );
}
